module.exports = __webpack_public_path__ + "img/header-weddingRingsModern.d9b4390.jpg";